const getCarePlanIdFromPath = (path) => {
  return path.split('/care_plans/').pop().split('/dashboard').shift();
};

export default getCarePlanIdFromPath;
